<template>
	<div>
		<v-row>
			<v-col>
				<v-text-field
				readonly
				v-model="user.firstName"
				label="Participant Name"
				></v-text-field>	
			</v-col>
			<v-col>
				<v-text-field
				readonly
				v-model="user.lastName"
				></v-text-field>	
			</v-col>
		</v-row>	
		<v-row>
			<v-col>
				<v-text-field
				readonly
				v-model="user.displayName"
				label="Display Name"
				></v-text-field>	
			</v-col>
		</v-row>	
		<v-row v-if="user.role == 'participant'">
			<v-col>
				<v-text-field
				readonly
				v-model="user.status"
				label="Participant Status"
				></v-text-field>	
			</v-col>
		</v-row>	
		<v-row>
			<v-col>
				<v-text-field
				v-model="user.email"
				label="Email"
				readonly
				></v-text-field>	
			</v-col>
			<v-col>
				<v-text-field
				v-model="user.phone"
				label="Phone"
				readonly
				></v-text-field>	

			</v-col>
		</v-row>

	</div>
</template>
<script>
	export default {
		name: "ViewUser", 
		props: {
			user: {type: Object}
		}
	}
</script>